__turbopack_context__.v({
  "modalRegistration": "modalRegistration-module-scss-module__ROByva__modalRegistration",
});
